import { useInView } from 'react-intersection-observer';
import './Benefits.css';

export const Benefits = () => {
  const { ref, inView } = useInView({
    threshold: window.innerWidth === 350 ? 0.44 : 0.22,
    triggerOnce: false,
  });

  const benefits = [
    {
      icon: 'assets/benefits_image_1.png',
      title: 'Photo-to-List AI',
      desc: 'Snap a photo and create a complete listing in seconds',
      type: 'small',
    },
    {
      icon: 'assets/benefits_image_2.png',
      title: 'Smart Categorization',
      desc: 'Get your listing placed correctly without manual effort',
      type: 'small',
    },
    {
      icon: 'assets/benefits_image_3.png',
      title: 'Better Visibility',
      desc: 'Optimized listings help you reach more buyers',
      type: 'very-small',
    },
    {
      icon: 'assets/benefits_image_4.png',
      title: 'Secure Chat',
      desc: 'Talk to buyers safely without sharing personal details',
      type: 'very-small',
    },
    {
      icon: 'assets/benefits_image_5.png',
      title: 'Instant Notifications',
      desc: 'Get real-time updates on messages and buyer interest',
      type: 'very-small',
    },
  ];

  return (
    <section ref={ref} className="benefits">
      <div className="container">
        <h2 className={`section-title fade-in-section ${inView ? 'is-visible' : ''}`}>
          What You Get with Qinto
        </h2>

        <div className="benefits-grid">
          {benefits.map((item, idx) => (
            <div
              key={idx}
              className={`benefit-card ${item.type} fade-in-section ${inView ? 'is-visible' : ''}`}
              style={{ transitionDelay: `${idx * 160}ms` }}
            >
              <img className="benefit-img" src={item.icon} alt={item.title} />
              <div className="benefit-overlay">
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
